export default __webpack_public_path__ + "static/integrationsBG-ec04e88d58e37c3dc2bd71fb81284e0e.webp";